/// <amd-module name="Search/Package/NavigationHandler" />

import { deserialize, areFiltersEqual, serializeFilters } from "Search/Shared/Utils";
import { IVssPageContext } from "VSS/Platform/Context";
import { IVssHistoryService } from "VSS/Platform/History"
import { IAggregatedState } from "Search/Package/Flux/StoresHub";
import { ActionCreator } from "Search/Package/Flux/ActionCreator";

export function updateUrl(
    pageContext: IVssPageContext,
    aggregateState: IAggregatedState): void {
    const historyService = pageContext.getService<IVssHistoryService>("IVssHistoryService");
    let params: { [key: string]: string } = {};
    const { searchStoreState } = aggregateState;
    const { query } = searchStoreState;

    let addHistoryPoint = false, replaceHistoryPoint = false;

    const currentParams = historyService.getState();

    if (query.searchText !== currentParams.text) {
        addHistoryPoint = true;
        params.text = query.searchText;
    }

    const filtersInUrl = deserialize<{ [id: string]: string[] }>(currentParams.filters) || {};
    if (!areFiltersEqual(query.filters, filtersInUrl)) {
        addHistoryPoint = true;
        params.filters = serializeFilters(query.filters)
    }

    const newParams = { ...currentParams, ...params };

    // Replace is given precedence over adding history.
    if (replaceHistoryPoint) {
        historyService.replaceState(newParams);
    } else if (addHistoryPoint) {
        historyService.pushState(newParams);
    }
}

export function applyNavigatedUrl(
    actionCreator: ActionCreator,
    rawState: { [key: string]: string },
    aggregateState: IAggregatedState): void {
    const { searchStoreState } = aggregateState;
    const { query } = searchStoreState;
    const filtersFromUrl = deserialize<{ [id: string]: string[] }>(rawState.filters) || {};

    let issueNewSearch = rawState.text && query.searchText !== rawState.text;
    issueNewSearch = issueNewSearch || !areFiltersEqual(filtersFromUrl, query.filters);

    if (issueNewSearch) {
        actionCreator.performSearch(rawState.text, filtersFromUrl);
    } else if (!rawState.text) {
        actionCreator.showLandingPage();
    }
}